import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

const Files = ({data}) => {
    const mobile = useSelector(state => state.mobile);

    return (
        <div className="docs">
            {
                data.map((item, i) => (
                    <a href={item.link} target={mobile ? "_self" : "_blank"} className={`docs__item docs__item_${item.type.toLowerCase()} fadeIn delay${i+1}00`} key={i}>
                        <div className="docs__type">{item.type}</div>
                        <div className="docs__title">{item.name}</div>
                        <div className="docs__meta">{item.type}, {item.size}</div>
                    </a>
                ))
            }                    
        </div>
    )
}

export default Files